export const blockIconsCommunicationCommentNew = (
	<span className='material-symbols-outlined'>comment</span>
);
